

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {  Popup } from "react-map-gl";


class NZ2026HomeTooltip extends Component {
 
  
             
buildTooltip(hoverInfo, styledGeo,tooltip_pastcomp) {
  const { geoLevel } = this.props; // 👈 bring it in
  if (!hoverInfo) return null;
  if (!styledGeo) return null;

  const { area_name, topLabel, area_id } = hoverInfo.props;

  // Find matching feature in styledGeo
  const comparatorFeature = styledGeo.features.find(
    f => f?.properties?.area_id === area_id
  );
  const comparator = comparatorFeature ? comparatorFeature?.properties : {};
  
  // Predicted vote shares (current prediction)
  const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);
  const Turnout = hoverInfo?.props?.Turnout? JSON.parse(hoverInfo?.props?.Turnout): null;

const partyConfig = {
  // GE / LE vote intention (proportions)
  D66_GE_p: { label: "D66", color: "#2cc800" },
  PVV_GE_p: { label: "PVV", color: "#043555" },
  VVD_GE_p: { label: "VVD", color: "#0e2783" },
  GLpvdA_GE_p: { label: "GL–PvdA", color: "#920c19" },
  CDA_GE_p: { label: "CDA", color: "#339933" },
  OtherRight_GE_p: { label: "Other right", color: "#7393B3" },
  OtherLeft_GE_p: { label: "Other left", color: "#997570" },
  OtherCentre_GE_p: { label: "Other centre", color: "#999999" },

  D66_LE_p: { label: "D66", color: "#2cc800" },
  PVV_LE_p: { label: "PVV", color: "#043555" },
  VVD_LE_p: { label: "VVD", color: "#0e2783" },
  GLpvdA_LE_p: { label: "GL–PvdA", color: "#920c19" },
  CDA_LE_p: { label: "CDA", color: "#339933" },
  OtherRight_LE_p: { label: "Other right", color: "#7393B3" },
  OtherLeft_LE_p: { label: "Other left", color: "#997570" },
  OtherCentre_LE_p: { label: "Other centre", color: "#999999" },

  // Past vote
  past_vote_CDA: { label: "CDA", color: "#339933" },
  past_vote_D66: { label: "D66", color: "#2cc800" },
  past_vote_DidNotVote: { label: "Did not vote", color: "#94A3B8" }, // not in PARTY_INFO, kept as-is
  past_vote_GLpvdA: { label: "GL–PvdA", color: "#920c19" },
  past_vote_OtherCentre: { label: "Other centre", color: "#999999" },
  past_vote_OtherLeft: { label: "Other left", color: "#997570" },
  past_vote_OtherRight: { label: "Other right", color: "#7393B3" },
  past_vote_PVV: { label: "PVV", color: "#043555" },
  past_vote_VVD: { label: "VVD", color: "#0e2783" },
};



  // Build vote share lines
  const voteLines = predictedValues.map(({ key, area_id }) => {
  const party = partyConfig[key];
  if (!party) return null;

  // current prediction (%)
  const predicted = area_id.toFixed(0);

  // determine which "previous" source to use
  let prev = null;

  if (tooltip_pastcomp === "no") {
    // use past_vote_ columns from styledGeo properties
    // map pred key (e.g., 'act_pred_n') -> corresponding past_vote column
    const pastVoteKey = key.replace("_GE_p", "").replace("_LE_p", "").replace(/^/, "");
    prev = comparator?.[pastVoteKey] ?? null; // already normalised (%)
  } else {
    const pastVoteKey = key.replace("_GE_p", "").replace("_LE_p", "").replace("past_vote_", "").replace(/^/, "");
    prev = comparator?.[pastVoteKey]*100 ?? null; // already normalised (%)
  }

  let change = "";
  if (prev !== null) {
    const diff = predicted - prev;
    change = ` (${diff > 0 ? "+" : ""}${diff.toFixed(0)}%)`;
  }

  return (
    <div key={key} style={{ color: party.color }}>
      {party.label}: {predicted}%
      {change}
    </div>
  );
});


  let area_type_label
  switch(geoLevel){
    case "geementen":
        area_type_label="Gemeente"
        break
    case "buurt":
        area_type_label="Buurt"
        break
    default:
        area_type_label=geoLevel
        break
        
  }

  return (
    <div style={{ fontSize: "13px" }}>
      <strong>{area_name}</strong> {area_type_label}
      <br />
      Winner: {topLabel}
      <br />
      Turnout: {Turnout ? Turnout.toFixed(0) + "%" : "n/a"}
      <br />
      <br />
      <div>Predicted vote shares</div>
     <div>  (change from nominal 2025 result):</div>
      {voteLines}
      <br />
      <small>
      </small>
    </div>
  );
}






 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

   
  return (
    <>
      {styledGeo && hoverInfo && hoverInfo?.props?.topValue>0 &&(
        <Popup
          longitude={hoverInfo.lon}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          offset={12}
          dynamicPosition={true}
          maxWidth="500px"
        >
          {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
        </Popup>
      )}
    </>
  );
}
}
    
    export default withRouter(NZ2026HomeTooltip);
    